// @flow strict

import axios from 'axios';
import type { AxiosXHRConfigBase } from 'axios';
import { raiseEventWithData } from '../lib/segment-actions';
import { NotFoundError, BadRequestError, UnknownError } from './apiError';

function handleHttpError(error: Object) {
  const { status = 0, data = { status: 0 } } = error.response || {};

  switch (status) {
    case 400:
      if (data.errors) {
        raiseEventWithData('Validation Failed', data.errors);
      }
      throw new BadRequestError(data);
    case 404:
      throw new NotFoundError(data);
    default:
      throw new UnknownError(data);
  }
}

// copied from axios_v0.19.x.js
type AxiosStub = {
  post<T, R>(url: string, data?: T, config?: any): Promise<R>,
  patch<T, R>(url: string, data?: T, config?: any): Promise<R>,
  get<R>(url: string, config?: any): Promise<R>,
  defaults: {|
    ...$Exact<AxiosXHRConfigBase<mixed>>,
    headers: any,
  |},
  interceptors: any,
};

export function createAxiosInstance(baseURL: string, moreConfig: any): AxiosStub {
  const axiosInstance: AxiosStub = axios.create({
    baseURL,
    ...moreConfig,
  });

  // Fix IE cache GET request
  axiosInstance.defaults.headers.common.Pragma = 'no-cache';
  axiosInstance.defaults.headers.common['Cache-Control'] = 'no-cache';

  axiosInstance.interceptors.response.use(
    (response: any) => response.data,
    (error: any) => handleHttpError(error),
  );

  return axiosInstance;
}
